import clsx from 'clsx'
import {components, ControlProps, GroupBase} from 'react-select'
import {cn} from 'src/app/utils/cn.utils'
import GIcon from '../../Icon/GIcon'

const Control = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  children,
  isFocused,
  isDisabled,
  ...rest
}: ControlProps<Option, IsMulti, Group>) => (
  <components.Control
    className={clsx('shadow-none min-h-[44px]', {
      focus: isFocused,
      disabled: isDisabled,
    })}
    isFocused
    isDisabled
    {...rest}
  >
    {children}
  </components.Control>
)

const IndicatorSeparator = () => null

const NoOptionsMessage = (props: any) => {
  return (
    <components.NoOptionsMessage {...props}>
      <div className='font-medium text-start'>Data tidak ditemukan</div>
    </components.NoOptionsMessage>
  )
}

const Option = (props: any) => (
  <components.Option {...props} className={cn({'bg-neutral-100': props.isSelected})}>
    <div className='flex items-center justify-between'>
      <p
        className={cn(
          'overflow-ellips-2 w-fit pl-4',
          {'text-neutral-700': props.isSelected},
          {'text-neutral-400': props.disabled}
        )}
      >
        {props.label}
      </p>

      {props.isSelected && (
        <GIcon icon='IconCheck' className={cn('w-5 h-5', {'text-primary-500': props.isSelected})} />
      )}
    </div>
  </components.Option>
)

const MultiValue = (props: any) => {
  return (
    <components.MultiValue {...props} className='rounded-xl bg-neutral-100 text-neutral-700'>
      {props.children}
    </components.MultiValue>
  )
}

const OptionSingle = (props: any) => (
  <components.Option {...props} className={cn({'bg-neutral-100': props.isSelected})}>
    <div className='flex items-center justify-between'>
      <p className={cn('overflow-ellips-2 w-fit pl-4')}>{props.label}</p>
    </div>
  </components.Option>
)

export interface LabelValueProps {
  label?: string
  value?: string
}

export interface IdNameProps {
  id?: string
  name?: string
}

export const CustomReactSelect = {
  Control,
  IndicatorSeparator,
  NoOptionsMessage,
  Option: OptionSingle,
}

export const CustomReactMultiSelect = {
  Control,
  IndicatorSeparator,
  NoOptionsMessage,
  Option,
  MultiValue,
}
